module.exports = __webpack_public_path__ + "static/media/event1.f49697f6.jpg";